export default __webpack_public_path__ + "static/media/ic-practice-test-g.52d208f7.svg";